import { SEARCH_AGGREGATES } from '@/utils/constants'
import { valueFormater as valueLocaleFormater } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { IFilterCopy, IFilterTag, ISelectedFilters } from '~types/search'

export interface ICurrencyFormat {
  style: string
  currencyDisplay: string
  minimumFractionDigits: number
  maximumFractionDigits: number
  currency: string
}

export const buildTagsForSelectedFilters = (
  {
    brands,
    categories,
    tags,
    availablePromotions,
    priceRanges,
    operationalModels,
  }: ISelectedFilters,
  copy: IFilterCopy,
  {
    currencyFormat,
    currencyLocale,
  }: {
    currencyFormat?: ICurrencyFormat
    currencyLocale?: string
  }
): IFilterTag[] => {
  const result = brands.map((brand) => ({
    type: SEARCH_AGGREGATES.brands,
    key: brand,
    label: brand,
  }))

  categories.forEach((category) =>
    result.push({
      type: SEARCH_AGGREGATES.categories,
      key: category,
      label: category,
    })
  )

  tags.forEach((tag) =>
    result.push({
      type: SEARCH_AGGREGATES.tags,
      key: tag,
      label: tag,
    })
  )

  availablePromotions.forEach((promotion) => {
    result.push({
      type: SEARCH_AGGREGATES.availablePromotions,
      key: promotion,
      label: copy.seePromotionalProducts,
    })
  })

  if (priceRanges.gte > 0) {
    const valueFormater = valueLocaleFormater(currencyLocale)(currencyFormat)
    result.push({
      type: SEARCH_AGGREGATES.priceRanges,
      key: SEARCH_AGGREGATES.priceRanges,
      label: `${copy.gt}: ${valueFormater(priceRanges.gte)} ${
        copy.lt
      }: ${valueFormater(priceRanges.lte)}`,
    })
  }
  operationalModels.forEach((operationalModel) =>
    result.push({
      type: 'operationalModels',
      key: operationalModel,
      label: operationalModel,
    })
  )
  return result
}

export default buildTagsForSelectedFilters
